export default {
    // 修改主导航激活状态
    changeNavName(state, name) {
        state.navName = name;
    },
    // 修改面包屑导航条内容
    changeCrumb(state, data) {
        if(data.cutOut) {
            state.crumb.splice(data.index, state.crumb.length+1, data.txt);
        }else {
            state.crumb.splice(data.index, 1, data.txt);
        }
    },
    changeBatt(state, data) {
        state.batt = data;
    },
}